import { render } from "./BookingsCalendar.vue?vue&type=template&id=1b95a9a1&scoped=true"
import script from "./BookingsCalendar.vue?vue&type=script&lang=js"
export * from "./BookingsCalendar.vue?vue&type=script&lang=js"

import "./BookingsCalendar.vue?vue&type=style&index=0&id=1b95a9a1&lang=scss&scoped=true"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b95a9a1"]])

export default __exports__